export default {
  navigationBarTitleText: '页面走丢了',
};
